import {
  CART_SHIPMENT_TYPES,
  VENDOR_SHIPPING_PREFIX,
  ARTA_SERVICE_TYPE,
} from 'constants/common'
import {
  findArtaShipmentServiceSubSubtypeByType,
  formatVendorShippingShipmentName,
  formatArtaShipmentName,
  formatFreightClubShipmentName,
} from 'utils/formatters'

export const formatCartShipmentVendorShipping = ({
  type,
  name,
  productVariantId,
}) => {
  const { shipmentMethodTitle, shipmentMethodDescription } =
    formatVendorShippingShipmentName({ name })
  return {
    shipmentMethodTitle,
    shipmentMethodDescription: shipmentMethodDescription ?? type,
    shipmentValue: `${VENDOR_SHIPPING_PREFIX}-${productVariantId}-${type}`,
  }
}

export const formatCartShipmentArtaQuote = ({
  services,
  additionalServices,
  type,
  name,
}) => {
  const { shipmentMethodTitle: title, shipmentMethodDescription: description } =
    formatArtaShipmentName({ services, type, name, additionalServices })
  const artaShipmentValue = findArtaShipmentServiceSubSubtypeByType({
    services,
    additionalServices,
    serviceType: ARTA_SERVICE_TYPE.TRANSPORT,
  })
  return {
    shipmentMethodTitle: title,
    shipmentMethodDescription: description,
    shipmentValue: artaShipmentValue,
  }
}

export const formatCartShipmentFreightClubQuote = ({ rawData, name }) => {
  const {
    request: { ServiceLevel },
  } = rawData
  const { shipmentMethodTitle, shipmentMethodDescription } =
    formatFreightClubShipmentName({ name, requestedType: ServiceLevel })
  return {
    shipmentMethodTitle,
    shipmentMethodDescription,
    shipmentValue: ServiceLevel,
  }
}

export const formatCartShipments = (input) => {
  const { __typename: typename } = input
  if (typename === CART_SHIPMENT_TYPES.VendorShipping) {
    return formatCartShipmentVendorShipping(input)
  }
  if (typename === CART_SHIPMENT_TYPES.ArtaQuote) {
    return formatCartShipmentArtaQuote(input)
  }
  if (typename === CART_SHIPMENT_TYPES.FreightClubQuote) {
    return formatCartShipmentFreightClubQuote(input)
  }
  return null
}
